import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { useAuth } from '../../../common/hooks/useAuth';
import { Role } from '../../../common/spdCore/authorization/roles';
import ConfirmationButton from '../../../app/components/ConfirmationButton';

export const NormBinLink = (props: {
  normId: string;
  setRefresh?: () => void;
}) => {
  const spd = useSpdCore();
  const auth = useAuth();

  if (!auth?.roles?.includes(Role.SuperAdmin)) {
    return null;
  }

  const handleClick = () => {
    spd.norms
      .delete(props.normId)
      .then(() => {
        if (props.setRefresh) {
          props.setRefresh();
        }
      })
      .catch(error =>
        console.log(`Wystąpił problem z usunięciem normy. ${error}`),
      );
  };

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div onClick={e => e.stopPropagation()}>
      <OverlayTrigger
        overlay={
          <Tooltip style={{ position: 'fixed' }}>Usunięcie normy</Tooltip>
        }
      >
        <ConfirmationButton
          className="ms-1"
          confirmation="Czy na pewno usunąć normę?"
          variant="btn-info"
          onOK={handleClick}
        >
          <Icon.Trash />
        </ConfirmationButton>
      </OverlayTrigger>
    </div>
  );
};
